<p-calendar
  [(ngModel)]="fecha"
  [locale]="es"
  dateFormat="dd/mm/yy"
  placeholder="..."
  appendTo="body"
  (onSelect)="markFieldAsChanged()"
  (ngModelChange)="markFieldAsChanged()"
>
</p-calendar>
